"use client"
import styled from "@emotion/styled"
import { sharedColors } from "@eurodrive/ui/theme/colors"
import { Box, Typography } from "@mui/material"

const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const StyledTagsContainer = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`

const StyledTag = styled(Box)<{ selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  border-radius: 4px;
  background-color: ${(props) =>
    props.selected ? sharedColors.darkGreen : sharedColors.lightGrey};
  color: ${(props) =>
    props.selected ? sharedColors.white : sharedColors.black};
  font-size: 16px;
  line-height: 140%;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
`

interface CarFeaturesSectionProps {
  selectedFeatures: string[]
  toggleFeature: (featureId: string) => void
  carFeatures: Array<{ id: string; label: string }>
}

function CarFeaturesSection({
  selectedFeatures,
  toggleFeature,
  carFeatures,
}: CarFeaturesSectionProps) {
  return (
    <StyledSection>
      <Typography variant="body2" fontWeight={600} id="carfeatures-group-label">
        מאפייני רכב
      </Typography>
      <StyledTagsContainer
        role="group"
        aria-labelledby="carfeatures-group-label"
      >
        {carFeatures.map((feature) => {
          const isSelected = selectedFeatures.includes(feature.id)
          return (
            <StyledTag
              key={feature.id}
              selected={isSelected}
              onClick={() => toggleFeature(feature.id)}
              role="checkbox"
              aria-checked={isSelected}
              tabIndex={0}
              onKeyDown={(e: React.KeyboardEvent) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault()
                  toggleFeature(feature.id)
                }
              }}
            >
              {feature.label}
            </StyledTag>
          )
        })}
      </StyledTagsContainer>
    </StyledSection>
  )
}

export default CarFeaturesSection
